const testimonialData = [
    {
        key: 0,
        quote: "' Talking to Eric is like talking to a friend, someone who will listen and support your vision '",
        author: "Client"
    },
    {
        key: 1,
        quote: "' Pretty good at web development, average at minecraft '",
        author: "Friend"
    },
    {
        key: 2,
        quote: "' Eric is the coolest. He didn't get offended even if I HATED something during the process. He listened and delivered exactly what I wanted '",
        author: "Client"
    },
    {
        key: 3,
        quote: "' Cool guy, great developer... what more could you ask for!? '",
        author: "Friend"
    },
    {
        key: 4,
        quote: "' Makes the best banana bread in town '",
        author: "Friend"
    },
    {
        key: 5,
        quote: "' He makes some pretty funny websites '",
        author: "Dad"
    },
    {
        key: 6,
        quote: "' Couldn't be happier with Eric's service. I changed my mind 1000 times and he made every change without complaint. If you're looking for a web developer that will go above and beyond, he is your man. '",
        author: "Client"
    },
    {
        key: 7,
        quote: "' Everyone's biggest cheerleader '",
        author: "Friend"
    },
    {
        key: 8,
        quote: "' If glass half full was a person it'd be Eric '",
        author: "Friend"
    },
    {
        key: 9,
        quote: "' Number one hype man with a heart of gold '",
        author: "Coworker"
    },
    {
        key: 10,
        quote: "' The websites created by Eric are visually appealing and easy to navigate '",
        author: "Mom"
    }
]

export default testimonialData;